import React, { useState } from "react";
import Changes from "components/CompanyDashboard/MaintainYourCompany/Changes";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";

const ChangesPage = () => {
  const [changeOfParticularsInfo, setChangeOfParticularsInfo] = useState({
    selectedValueType: "",
  });
  const [transactionId, setTransactionId] = useState(null);
  const [appointmentStatus, setAppointmentStatus] = useState(false);
  const [isManageCompanyForm, setIsManageCompanyForm] = useState(null);
  const [transactionPayload, setTransactionPayload] = useState({
    officials: [],
    changeOfParticularDate: null,
    applicationType: null,
    status: "DRAFT",
    companyId: null,
    changeType: "CHANGE-OF-PARTICULARS",
    trx: null,
  });

  const handleBackToManageYourCompanyDashboard = () => {
    // define whatever navigation logic this page needs
  };

  const handleGoToDraft = () => {
    // define if needed
  };

  return (
    <ManageModuleContext.Provider
      value={{
        currentStateOfProcess: "company-changes",
        appointmentStatus,
        setAppointmentStatus,
        appointmentInfo: { idType: "KENYAN_CITIZEN" },
        cessationInfo: {},
        isManageCompanyForm,
        setIsManageCompanyForm,
        handleBackToManageYourCompanyDashboard,
        handleGoToDraft,
        changeOfParticularsInfo,
        setChangeOfParticularsInfo,
        transactionId,
        setTransactionId,
        transactionPayload,
        setTransactionPayload,
      }}
    >
      <CompanyDashboardWrapper>
        <Changes />
      </CompanyDashboardWrapper>
    </ManageModuleContext.Provider>
  );
};

export default ChangesPage;